import GraphicTableFilter from './graphic-table-filter';

export default GraphicTableFilter;